document.addEventListener('DOMContentLoaded', () => {
  const components = document.querySelectorAll('.pack-feature');
  components.forEach((component) => {
    const containers = Array.from(component.querySelectorAll('.pack-feature__container'));
    if (containers.length <= 1) return;

    // Ensure exactly one is visible at start
    let currentIndex = containers.findIndex((el) => !el.classList.contains('is-hidden'));
    if (currentIndex === -1) {
      currentIndex = 0;
      containers.forEach((el, idx) => el.classList.toggle('is-hidden', idx !== 0));
    }

    const showIndex = (nextIndex) => {
      containers.forEach((el, idx) => {
        if (idx === nextIndex) {
          el.classList.remove('is-hidden');
        } else {
          el.classList.add('is-hidden');
        }
      });
      currentIndex = nextIndex;
    };

    const nextBtn = component.querySelector('.pack-feature__nav-next');
    const prevBtn = component.querySelector('.pack-feature__nav-prev');
    if (nextBtn) {
      nextBtn.addEventListener('click', (event) => {
        event.preventDefault();
        const nextIndex = (currentIndex + 1) % containers.length;
        showIndex(nextIndex);
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', (event) => {
        event.preventDefault();
        const prevIndex = (currentIndex - 1 + containers.length) % containers.length;
        showIndex(prevIndex);
      });
    }
  });
});
